import React, { useState } from 'react';

const ImportPreview = ({ data, fileName, onConfirm, onCancel }) => {
  const [selectedRows, setSelectedRows] = useState([...Array(data.length)].map((_, i) => i));
  
  const totalRows = data.length;
  const selectedCount = selectedRows.length;
  
  const toggleAll = () => {
    if (selectedRows.length === data.length) {
      setSelectedRows([]);
    } else {
      setSelectedRows([...Array(data.length)].map((_, i) => i));
    }
  };
  
  const toggleRow = (index) => {
    if (selectedRows.includes(index)) {
      setSelectedRows(selectedRows.filter(i => i !== index));
    } else {
      setSelectedRows([...selectedRows, index]);
    }
  };
  
  const getFilteredData = () => {
    return data.filter((_, index) => selectedRows.includes(index));
  };
  
  return (
    <div className="bg-white shadow rounded-lg overflow-hidden">
      <div className="px-4 py-5 sm:p-6">
        <h3 className="text-lg font-medium leading-6 text-gray-900 mb-4">
          {fileName === 'Clients existants' 
            ? 'Aperçu des clients existants' 
            : `Aperçu de l'import - ${fileName}`}
        </h3>
        
        <div className="flex items-center justify-between mb-4">
          <div className="flex items-center">
            <input
              type="checkbox"
              className="h-4 w-4 text-[#174540] focus:ring-[#174540] border-gray-300 rounded"
              checked={selectedRows.length === data.length}
              onChange={toggleAll}
            />
            <span className="ml-2 text-sm text-gray-700">
              {selectedCount} sur {totalRows} sélectionné(s)
            </span>
          </div>
          
          <div className="flex space-x-2">
            <button
              type="button"
              className={`inline-flex items-center px-4 py-2 border border-transparent text-sm font-medium rounded-md ${
                selectedCount === 0 
                ? 'bg-gray-300 text-gray-500 cursor-not-allowed' 
                : 'bg-[#174540] text-white hover:bg-[#0d2926] focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-[#174540]'
              }`}
              onClick={() => onConfirm(getFilteredData())}
              disabled={selectedCount === 0}
            >
              Importer {selectedCount} contact{selectedCount > 1 ? 's' : ''}
            </button>
            
            <button
              type="button"
              className="inline-flex items-center px-4 py-2 border border-gray-300 shadow-sm text-sm font-medium rounded-md text-gray-700 bg-white hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-[#174540]"
              onClick={onCancel}
            >
              Annuler
            </button>
          </div>
        </div>
        
        <div className="overflow-x-auto rounded-md border border-gray-200">
          <table className="min-w-full divide-y divide-gray-200">
            <thead className="bg-gray-50">
              <tr>
                <th scope="col" className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                  <input
                    type="checkbox"
                    className="h-4 w-4 text-[#174540] focus:ring-[#174540] border-gray-300 rounded"
                    checked={selectedRows.length === data.length}
                    onChange={toggleAll}
                  />
                </th>
                <th scope="col" className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                  Prénom
                </th>
                <th scope="col" className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                  Nom
                </th>
                <th scope="col" className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                  Téléphone
                </th>
              </tr>
            </thead>
            <tbody className="bg-white divide-y divide-gray-200">
              {data.map((row, index) => (
                <tr key={index} className={selectedRows.includes(index) ? 'bg-blue-50' : 'hover:bg-gray-50'}>
                  <td className="px-6 py-4 whitespace-nowrap">
                    <input
                      type="checkbox"
                      className="h-4 w-4 text-[#174540] focus:ring-[#174540] border-gray-300 rounded"
                      checked={selectedRows.includes(index)}
                      onChange={() => toggleRow(index)}
                    />
                  </td>
                  <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-900">
                    {row.firstName || '-'}
                  </td>
                  <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-900">
                    {row.lastName || '-'}
                  </td>
                  <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-900">
                    {row.phone}
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
};

export default ImportPreview;